<template>
  <div>
    <CContainer>
      <CRow
        v-if="user.role.name !== 'student'"
        class="justify-content-center mt-4"
      >
        <CCol md="12" class="text-center">
          <h1 class="mb-2">
            {{
              editablePass ? "Edit Appointment Pass" : "Create Appointment Pass"
            }}
            <HelpCenterButton
              classes="me-2"
              content-key="appointment_pass_form"
            />
          </h1>
          <span v-if="!editablePass"
            >School Time zone {{ school.timezone }} {{ currentDateTime }}</span
          >
          <CreateApptMultipleForm
            :periods="periods"
            :editable-pass="editablePass"
            is-in-view="true"
          />
        </CCol>
      </CRow>
    </CContainer>
    <AdultAptPassDataTable v-if="user.role.name !== 'student'" />
    <StudentAptPassDataTable v-if="user.role.name === 'student'" />
  </div>
</template>
<script>
import AdultAptPassDataTable from "@/components/DataTables/AdultAptPassDataTable/AdultAptPassDataTable"
import StudentAptPassDataTable from "@/components/DataTables/StudentAptPassDataTable/StudentAptPassDataTable"
import HelpCenterButton from "@/components/HelpCenterButton"
import CreateApptMultipleForm from "@/components/Forms/CreateApptMultipleForm"
import moment from "moment-timezone"
import { mapGetters } from "vuex"

export default {
  name: "AppointmentPass",
  components: {
    HelpCenterButton,
    CreateApptMultipleForm,
    StudentAptPassDataTable,
    AdultAptPassDataTable
  },
  computed: {
    ...mapGetters({
      user: "authentication/user",
      periods: "periods/formListStudents",
      editablePass: "adultAptPass/editablePass",
      school: "schools/activeSchool"
    })
  },
  data() {
    return {
      currentDateTime: moment().format("dddd, MMM DD, YYYY hh:mm A")
    }
  },
  methods: {}
}
</script>
